import { OrderSteps } from "@payping/api/app/api/bnplConsumerTypes";
import { ReduxActionGeneric } from "../actions/types";

export enum DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE {
  SET_LAST_URL_WAS_PAGE = "SET_LAST_URL_WAS_PAGE",
  SET_PAY_ORDER_STEP = "SET_PAY_ORDER_STEP",
  SET_RETRY_GET_ORDER = "SET_RETRY_GET_ORDER",
  SET_OPEN_GET_ORDER_OPEN_IN_MOBILE_MODAL = "SET_OPEN_GET_ORDER_OPEN_IN_MOBILE_MODAL",
  SET_CLOSE_GET_ORDER_OPEN_IN_MOBILE_MODAL = "SET_CLOSE_GET_ORDER_OPEN_IN_MOBILE_MODAL",
  SET_OPEN_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL = "SET_OPEN_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL",
  SET_CLOSE_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL = "SET_CLOSE_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL",
}

export type DashboardReduxReducerActions = {
  setLastUrlWasPage: (
    url: string,
  ) => ReduxActionGeneric<typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_LAST_URL_WAS_PAGE, string>;

  setPayOrderStep: (
    step?: OrderSteps,
  ) => ReduxActionGeneric<typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_PAY_ORDER_STEP, OrderSteps | undefined>;
  setRetryGetOrder: (
    step: RetryGetOrderSteps,
  ) => ReduxActionGeneric<typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_RETRY_GET_ORDER, RetryGetOrderSteps>;
  setCloseGetOrderOpenInMobileModal: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_MOBILE_MODAL,
    false
  >;
  setOpenGetOrderOpenInMobileModal: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_MOBILE_MODAL,
    true
  >;
  setCloseGetOrderOpenInSupportedDevices: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL,
    false
  >;
  setOpenGetOrderOpenInSupportedDevices: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL,
    true
  >;
};

type DashboardReduxReducerActionsReturn = ReturnType<DashboardReduxReducerActions[keyof DashboardReduxReducerActions]>;

export enum RetryGetOrderSteps {
  startGetOrder = 0,
  endGetOrder = 1,
  disable = 2,
}
export interface DashboardReduxReducerState {
  lastUrlWasPage?: string;
  payOrderStep?: OrderSteps;
  retryGetOrder: RetryGetOrderSteps;
  getOrderOpenInMobileModal: boolean;
  getOrderOpenInSupportedDevicesModal: boolean;
}

export const initialState: DashboardReduxReducerState = {
  lastUrlWasPage: undefined,
  payOrderStep: undefined,
  retryGetOrder: RetryGetOrderSteps.disable,
  getOrderOpenInMobileModal: false,
  getOrderOpenInSupportedDevicesModal: false,
};

function DashboardReduxReducer(
  // eslint-disable-next-line default-param-last
  state: DashboardReduxReducerState = initialState,
  action: DashboardReduxReducerActionsReturn,
): DashboardReduxReducerState {
  switch (action.type) {
    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_LAST_URL_WAS_PAGE:
      return {
        ...state,
        lastUrlWasPage: action.payload,
      };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_PAY_ORDER_STEP:
      return {
        ...state,
        payOrderStep: action.payload,
      };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_RETRY_GET_ORDER:
      return { ...state, retryGetOrder: action.payload };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_MOBILE_MODAL:
      return { ...state, getOrderOpenInMobileModal: false };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_MOBILE_MODAL:
      return { ...state, getOrderOpenInMobileModal: true };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL:
      return { ...state, getOrderOpenInSupportedDevicesModal: false };

    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL:
      return { ...state, getOrderOpenInSupportedDevicesModal: true };

    default:
      return state || initialState;
  }
}

export default DashboardReduxReducer;
